import { ThemeToggleButton } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

/**
 * ThemeToggleButton showcase.
 *
 * The toggle calls `useTheme()`, and the provider it reads is the playground's
 * root one — so pressing it switches the real page theme, which is what the
 * component does in an app. A demo-scoped `<ThemeProvider>` used to wrap this
 * to avoid "fighting" the page toggle, but it could not: ThemeProvider applies
 * the light/dark class to <html>, so the scoped copy just overrode the page
 * theme for as long as this demo was mounted.
 */
export function ThemeToggleButtonDemo() {
  return (
    <Section
      id="theme-toggle-button"
      title="ThemeToggleButton"
      description="Light/dark toggle wired to ThemeProvider, in the Onyx 'offset key' language. A ROUND/icon rail control, so it keeps its shape and shares the press language only via the springy 1px press-DOWN on :active (the same overshoot bounce every Button/IconButton uses) — no notch, no travel block. The sun/moon glyph swaps with the resolved theme; aria-pressed conveys the state. rail (icon tile with a hover-reveal label) · inline (labelled pill)."
    >
      <VariantBlock label="Variants">
        <ThemeToggleButton variant="rail" />
        <ThemeToggleButton variant="inline" />
      </VariantBlock>

      <VariantBlock label="Rail sizes" caption="icon-only tile sized to the NavRail foot">
        <ThemeToggleButton variant="rail" size="default" />
        <ThemeToggleButton variant="rail" size="compact" />
      </VariantBlock>

      <VariantBlock label="States">
        <ThemeToggleButton variant="rail" disabled />
        <ThemeToggleButton variant="inline" disabled />
      </VariantBlock>
    </Section>
  );
}
